import React from 'react';
import { StyledSVGButton } from '@/styles/GlobalStyles';
import styled from '@emotion/styled';
import ProfileCardPopper from '@/components/@IntranetLibrary/ProfileCard/ProfileCardPopper';
import usePopper from '@/hooks/usePopper';
import { InternalParticipant } from '@/types/api';
import ProfileImage from '@/components/Record/SubjectContent/ProfileImage';
import Xbutton from '@/components/Record/SubjectContent/Xbutton';

type P = {
  data?: InternalParticipant;
  title?: string;
  handleDelete?(title: string): void;
  shareMode?: boolean;
  isFocused?: boolean;
};

const AttenderItem = ({
  data,
  title,
  handleDelete,
  shareMode,
  isFocused,
}: P) => {
  const { anchorEl, openPopper, closePopper } = usePopper<HTMLButtonElement>();

  const onClick = () => {
    data && handleDelete?.(data.passportId);
    title && handleDelete?.(title);
  };

  return (
    <ContainerButton type="button" shareMode={shareMode} isFocused={isFocused}>
      {data && (
        <>
          <button
            type="button"
            onClick={openPopper}
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: 0,
              fontSize: '12px',
            }}
          >
            <ProfileImage
              url={data.profileImageUrl}
              id={`${data.passportId}-profile`}
            />
            <StyledTitle>
              {data.name} {data.positionName}
            </StyledTitle>
          </button>
          <ProfileCardPopper
            passportId={data.passportId}
            anchorEl={anchorEl}
            onClose={closePopper}
          />
        </>
      )}
      {title && <StyledTitle>{title}</StyledTitle>}
      {handleDelete && <Xbutton onClick={onClick} />}
    </ContainerButton>
  );
};

export default AttenderItem;

const ContainerButton = styled.button<{
  shareMode?: boolean;
  isFocused?: boolean;
}>`
  display: flex;
  align-items: center;
  border: 1px solid var(--dk-line, #e7e9ec);
  border-radius: 4px;
  padding: 4px;
  background-color: ${({ shareMode, isFocused }) => {
    if (isFocused) return '#e7e9ec';
    return shareMode ? 'rgba(0, 102, 204, 0.10)' : '#f9fafb';
  }};
  :hover {
    background-color: var(--dk-bg-muted, #f3f5f6);
  }
  width: fit-content;
  min-height: 30px;
`;

const EraseButton = styled(StyledSVGButton)`
  padding: 3px;
  line-height: 0;
  border-radius: 2px;
  :hover {
    background-color: var(--dk-bg-strong, #e7e9ec);
  }
`;

const StyledTitle = styled.div`
  white-space: nowrap;
  padding: 0 4px;
`;
